<script setup lang="ts">
import FormCategoria from '../components/form-categoria.vue'
import { useCategoriaStore } from '../store/useCategoriaStore'

definePage({
  meta: {
    action: 'edit',
    subject: 'categoria',
    navActiveLink: 'admin-categoria-fornecedor',
  },
})

const store = useCategoriaStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormCategoria is-editing />
</template>
